import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {DataTableColumnData} from '@cas-hub/acabim-common-client';

@Component({
    selector: 'acabim-admin-confirm-delete-modal',
    templateUrl: './confirm-delete-modal.component.html',
    styleUrls: ['./confirm-delete-modal.component.scss']
})
export class ConfirmDeleteModalComponent implements OnInit {
    @Input() deleteData = [];
    @Output() out = new EventEmitter<string>();
    @Input() columnData: DataTableColumnData[] = [];

    deleteMeta: any;
    deletePayload: any[] = [];

    constructor() {
    }

    ngOnInit(): void {
        if (this.deleteData.length > 0) {
            this.deleteMeta = {
                title: 'Confirm Delete',
                columns: ['', ''],
                showColumn: false
            };

            const emptypayload = {
                label: '',
                value: ['']
            };
            this.deleteData.forEach(data => {
                // tslint:disable-next-line:forin
                for (const key in data) {
                    const results = this.columnData.filter(entry => entry.objectPropertyName === key);
                    if (data[key] !== null && results.length > 0) {
                        const payload = {
                            label: results[0].displayName,
                            value: [data[key]]
                        };
                        this.deletePayload.push(payload);
                    }

                }
                this.deletePayload.push(emptypayload);
            });

        }
    }

    cancel(data: string) {
        if (data === 'cancel') {
            this.out.emit('cancel');
        } else if (data === 'delete') {
            this.out.emit('delete');
        }

    }
}
